import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LsqLoadingModalComponent } from './components/modals/lsq-loading-modal.component';
import { LsqQuestionModalComponent } from './components/modals/lsq-question-modal/lsq-question-modal.component';
import { LsqUnsupportedBrowserModalComponent } from './components/modals/unsupported-browser.modal.component';
import { LsqHelpModalComponent } from './components/pages/login/lsq-help-modal.component';
import { LsqModalComponent } from './components/ui-elements/modal/lsq-modal.component';
import { LsqCoreModule } from './core';
import { LsqFormsModule } from './forms';
import { ForgotPasswordModal } from './modals/forgot-password.modal';
import { LsqLoadingModal } from './modals/lsq-loading.modal';
import { UnsupportedBrowserModal } from './modals/unsupported-browser.modal';
import { Modal } from './models/common';
import { ModalWorkflowService } from './services/modal/modal-workflow.service';
import { ModalService } from './services/modal/modal.service';

export {
    LsqLoadingModalComponent,
    LsqQuestionModalComponent,
    LsqUnsupportedBrowserModalComponent,
    LsqModalComponent,
    ForgotPasswordModal,
    LsqLoadingModal,
    UnsupportedBrowserModal,
    ModalService,
    ModalWorkflowService,
    Modal,
    LsqHelpModalComponent
};

export * from './constants/modal.constants';

@NgModule({
    imports: [CommonModule, LsqCoreModule.forChild(), LsqFormsModule],
    declarations: [
        LsqLoadingModalComponent,
        LsqQuestionModalComponent,
        LsqUnsupportedBrowserModalComponent,
        LsqModalComponent,
        LsqHelpModalComponent
    ],
    exports: [
        LsqLoadingModalComponent,
        LsqQuestionModalComponent,
        LsqUnsupportedBrowserModalComponent,
        LsqModalComponent,
        LsqHelpModalComponent
    ]
})
export class LsqModalsModule {
    constructor() {
        console.debug('Loading libs/LsqModalsModule.');
    }
}
